if (!customElements.get('discount-code')) {
  class DiscountCode extends HTMLElement {
    constructor() {
      super();
      this.discountCode = this.querySelector('.js-discount-code');
      this.discountCodeBtn = this.querySelector('.js-copy-button');
      this.copySuccess = this.querySelector('.js-copy-success');

      if (this.discountCode && this.discountCodeBtn && this.copySuccess) {
        this.init();
      }
    }

    init() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        this.discountCodeBtn.addEventListener('click', this.copyCode.bind(this));
        this.discountCode.addEventListener('click', this.copyCode.bind(this));
      } else {
        this.discountCodeBtn.hidden = true;
      }
    }

    copyCode() {
      const discountCode = this.discountCode.textContent.trim();

      navigator.clipboard.writeText(discountCode).then(
        () => {
          this.copySuccess.classList.add('is-visible');
          this.copySuccess.setAttribute('aria-hidden', false);

          setTimeout(() => {
            this.copySuccess.classList.add('is-closing');
          }, 1800);

          setTimeout(() => {
            this.copySuccess.classList.remove('is-closing');
            this.copySuccess.classList.remove('is-visible');
          }, 2000);
        },
        () => {
          alert(theme.strings.discountCopyFail);
        }
      );
    }
  }

  customElements.define('discount-code', DiscountCode);
}

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.copy-code-btn');

  if (!btn) return;

  e.preventDefault();

  const code = btn.dataset.code || 'EOFY';

  navigator.clipboard.writeText(code).then(function() {
    const oldText = btn.innerHTML;

    btn.innerHTML = 'COPIED!';

    setTimeout(function() {
      btn.innerHTML = oldText;
    }, 2000);
  });
});